import React, { useEffect, useState } from 'react'
import CreateCompany from '../../components/companies/create-company/CreateCompany'
import PageBar from '../../components/dashboard/page-bar/PageBar'
import axios from 'axios'

const CreateCompanyPage = () => {
  const [data, setData] = useState({
    industrys: [],
    owners: [],
    contry: [],
    state: [],
    city: [],
  })
  const getAllData = async () => {
    const indus = await axios.get(
      `https://abarishr.hennainternational.in/api/industry/public`
    );
    const owner = await axios.get(
      `https://abarishr.hennainternational.in/api/ownership-type/public`
    );
    const resCountryData = await axios.get(
      `https://abarishr.hennainternational.in/api/countries/public`
    );
    // const states = await axios.get(
    //   `https://abarishr.hennainternational.in/api/states`
    // );
    const cities = await axios.get(
      `https://abarishr.hennainternational.in/api/location/all-location`
    );
    setData({
      ...data,
      industrys: indus.data?.data,
      owners: owner?.data?.data,
      contry: resCountryData.data?.data,
      // state: states.data,
      city: cities.data
    })
  }
  useEffect(() => {
    getAllData()
  }, [])
  return (
    <>
      <div className="pageWrapper">
        <PageBar title="Add Company" />
        <CreateCompany dataAll={data} />
      </div>
    </>
  )
}

export default CreateCompanyPage